import React from 'react';
import { motion } from 'framer-motion';
export function Hook() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-127">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto text-center" data-id="element-128">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 leading-snug" data-id="element-129">
          ¿Sientes que el mundo digital va más rápido que tú?
        </h2>
        <p className="text-lg md:text-xl text-brand-text mb-6 leading-relaxed" data-id="element-130">
          Mientras tus hijos o alumnos ya están usando la Inteligencia
          Artificial para sus tareas, muchos padres y profesores observan desde
          la barrera con una mezcla de miedo, duda y la sensación de estarse
          quedando atrás.
        </p>
        <p className="text-lg md:text-xl text-brand-text font-medium leading-relaxed" data-id="element-131">
          No eres el único. La brecha generacional tecnológica es real, pero no
          tiene por qué ser un abismo.{' '}
          <span className="text-brand-blue font-bold" data-id="element-132">
            La IA no ha venido a reemplazar tu capacidad de educar, sino a
            potenciarla
          </span>
          , si sabes cómo hablarle.
        </p>
      </motion.div>
    </section>;
}